import { MoreMenu, type MenuItem } from '@ui';
import { useTranslation } from 'react-i18next';
import { useSession } from '../../identity/session';
import { csvUrl, listPermission, type ExportList } from '../api';

/** Menu items to download a list as CSV (EXP-001); empty without read permission. */
export function useExportItems(list: ExportList): MenuItem[] {
  const { t } = useTranslation();
  const { can } = useSession();
  if (!can(listPermission[list])) return [];
  return [
    {
      key: 'csv',
      label: t('reports.csv.export'),
      onSelect: () => window.location.assign(csvUrl(list)),
    },
  ];
}

/** The page's `…` menu with the CSV export, for lists without other secondary actions. */
export function ExportButton({ list }: { list: ExportList }) {
  const { t } = useTranslation();
  const items = useExportItems(list);
  if (items.length === 0) return null;
  return <MoreMenu label={t('common.moreActions')} items={items} />;
}
